import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';

import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

import styles from './SbRespSearchResultGrid.scss';

export const PROMINENT_TILE = 'PROMINENT_TILE';
const SIDE_TILE = 'SIDE_TILE';
export const REGULAR_TILE = 'REGULAR_TILE';

const PROMINENT_TILE_GRID = 'prominent';

const ITEM_MODULO = 9;
const ROW_MODULO = 3;

function renderItem(item) {
    return item ? item : null;
}

function getTileType(index) {
    if (index % ITEM_MODULO === 0) {
        return PROMINENT_TILE;
    } else if ((index - 1) % ITEM_MODULO === 0 || (index - 2) % ITEM_MODULO === 0) {
        return SIDE_TILE;
    }

    return REGULAR_TILE;
}

function defaultItemsMap(items, children) {
    return items.map(({ node: item }, index) => (
        <Fragment key={item.serviceId}>
            {children({ item, index, tileType: REGULAR_TILE })}
        </Fragment>
    ));
}

function SbRespSearchResultGrid({ items, children, type }) {
    const { isDesktop } = useContext(ServerVarsContext);

    switch (type) {
        case PROMINENT_TILE_GRID: {
            if (!isDesktop) {
                return defaultItemsMap(items, children);
            }

            const mappedItems = items.map(({ node: item }, index) => {
                const tileType = getTileType(index);
                const className = {
                    [PROMINENT_TILE]: styles.prominentTile,
                    [SIDE_TILE]: styles.sideTile,
                    [REGULAR_TILE]: '',
                }[tileType];

                return (
                    <Fragment key={item.serviceId}>
                        {children({ item, index, customTileWidthClass: className, tileType })}
                    </Fragment>
                );
            });

            const chunkedItems = mappedItems.reduce((acc, value, index) => {
                if (index % ROW_MODULO === 0) {
                    acc.push([value]);
                } else {
                    acc[acc.length - 1].push(value);
                }
                return acc;
            }, []);

            return chunkedItems.map((itemsGroup, index) =>
                index % ROW_MODULO === 0 ? (
                    <Fragment key={`${index}-item-row`}>
                        {renderItem(itemsGroup[0])}
                        {itemsGroup.length > 1 && (
                            <div className={styles.wrapper}>
                                {renderItem(itemsGroup[1])}
                                {renderItem(itemsGroup[2])}
                            </div>
                        )}
                    </Fragment>
                ) : (
                    <Fragment key={`${index}-item-row`}>{itemsGroup}</Fragment>
                )
            );
        }
        default:
            // default to regular 3 column grid
            return defaultItemsMap(items, children);
    }
}

SbRespSearchResultGrid.propTypes = {
    children: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    type: PropTypes.string,
};

export { SbRespSearchResultGrid };
